import React from "react"
import { connect } from "react-redux"
import { AuthActions } from "redux-store/models"
import { Card, Icon, Table } from "antd"
import { Area } from "@ant-design/plots"
import { baseUrlImg } from "../../../config/api"

const TableStatistiche = (props) => {
  const { stats, images } = props

  const totalAll =
    stats && Object.values(stats).reduce((sum, s) => sum + (s.total_amount || 0), 0)

  const servicesArray =
    stats &&
    Object.entries(stats).map(([serviceName, values]) => ({
      serviceName,
      totale: values.total_amount,
      crescita: totalAll > 0 ? (values.total_amount / totalAll) * 100 : 0,
      icon_id: values.company?.icon_id,
    }))

  const orderedServices =
    servicesArray && servicesArray.sort((a, b) => b.totale - a.totale).slice(0, 5)

  const dataArray =
    orderedServices?.map((s) => ({
      serviceName: s.serviceName,
      value: s.totale,
    })) || []

  const config = {
    data: dataArray,
    padding: "auto",
    xField: "serviceName",
    yField: "value",
    smooth: true,
    color: "#0078FF",
    lineStyle: {
      shadowColor: "#0078FF",
      shadowBlur: 10,
      shadowOffsetX: 1,
      shadowOffsetY: 3,
      cursor: "pointer",
    },
    areaStyle: () => ({
      fill: "l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff",
    }),
  }

  const columns = [
    {
      title: "Posto",
      dataIndex: "posto",
      key: "posto",
      width: "10%",
      align: "center",
      ellipsis: true,
    },
    {
      title: "Servizio",
      dataIndex: "servizio",
      key: "servizio",
      width: "40%",
      ellipsis: true,
      render: (text, record) => {
        const icon = images?.find((img) => img.id === record.icon_id)

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {icon && (
              <img
                src={`${baseUrlImg}/${icon.path_slug}`}
                alt={icon.name}
                style={{ height: "20px", width: "20px" }}
              />
            )}
            <span>{text}</span>
          </div>
        )
      },
    },
    {
      title: "Totale",
      dataIndex: "totale",
      key: "totale",
      width: "25%",
      render: (value) => `${value.toFixed(2)}`,
      align: "center",
      sorter: (a, b) => a.totale - b.totale,
    },
    {
      title: "Crescita",
      dataIndex: "crescita",
      key: "crescita",
      width: "25%",
      render: (value) => `${value.toFixed(2)}%`,
      align: "center",
      sorter: (a, b) => a.crescita - b.crescita,
    },
  ]

  const dataSource =
    orderedServices?.map((s, i) => ({
      posto: i + 1,
      servizio: s.serviceName,
      totale: s.totale,
      crescita: s.crescita,
      icon_id: s.icon_id,
    })) || []

  return (
    <div className="table-statistiche">
      <Card
        title="Prodotto più venduto"
        bordered={false}
        extra={<Icon type="ellipsis" key="ellipsis" />}
      >
        <Area {...config} style={{ height: "150px" }} />
        <Table
          dataSource={dataSource}
          columns={columns}
          rowKey={(record, i) => i}
          pagination={false}
        />
      </Card>
    </div>
  )
}

const mapStateToProps = (state) => ({
  stats: state.main.stats,
  images: state.main.images,
})

export default connect(mapStateToProps, AuthActions)(TableStatistiche)
